import { on } from "delegated-events";
import ajax from "@common/scripts/ajax";
import { showFieldError } from "@common/scripts/validation";

const showUploadError = async (error, form, fieldName) => {
  let message = "There was a problem uploading your file. Please try again.";

  if (error && error.response) {
    try {
      const body = await error.response.json();
      if (body && body.error) {
        message = body.error;
      }
    } catch (parseError) {
      // Response body was not JSON; keep the default message.
    }
  }

  showFieldError(form, fieldName, message);
};

const appendFormSecurity = (form, data) => {
  const securityIdInput = form.querySelector('[name="SecurityID"]');
  if (securityIdInput) {
    data.append("SecurityID", securityIdInput.value);
  }

  const sessionTokenInput = form.querySelector('[name="SessionToken"]');
  const securityHashInput = form.querySelector('[name="SecurityHash"]');
  if (sessionTokenInput && securityHashInput) {
    data.append("SessionToken", sessionTokenInput.value);
    data.append("SecurityHash", securityHashInput.value);
  }
};

export default {
  init: () => {
    on("change", '.styled-form input[type="file"]:not(.additional-upload)', async (e) => {
      const input = e.target;
      const field = input.closest(".field");

      if (input.files.length === 0) {
        return;
      }

      const form = input.closest("form");
      const endpoint = form.dataset.uploadEndpoint;

      const data = new FormData();

      data.append("FieldName", input.name);
      data.append("FieldTitle", input.dataset.title);
      data.append("Required", field.dataset.required);
      data.append("Replacing", true);
      data.append("File", input.files[0]);
      appendFormSecurity(form, data);

      input.disabled = true;
      field.classList.add("is-loading");

      try {
        const res = await ajax.post(endpoint, { body: data }).text();
        const fieldHtml = document.createRange().createContextualFragment(res);

        field.replaceWith(fieldHtml);
      } catch (error) {
        console.error(error);
        await showUploadError(error, form, input.name);
      } finally {
        input.disabled = false;
        field.classList.remove("is-loading");
      }
    });

    on("change", '.styled-form input[type="file"].additional-upload', async (e) => {
      const input = e.target;
      const field = input.closest(".field");

      if (input.files.length === 0) {
        return;
      }

      const form = input.closest("form");
      const endpoint = form.dataset.uploadEndpoint;
      const holder = form.querySelector(".additional-documents-holder");

      const data = new FormData();

      data.append("Additional", true);
      data.append("Required", false);
      data.append("File", input.files[0]);
      appendFormSecurity(form, data);

      input.disabled = true;
      field.classList.add("is-loading");

      try {
        const res = await ajax.post(endpoint, { body: data }).text();
        const fieldHtml = document.createRange().createContextualFragment(res);
        holder.appendChild(fieldHtml);
        holder.offsetHeight;
        holder.lastElementChild.classList.add("is-enter");
      } catch (error) {
        console.error(error);
        await showUploadError(error, form, input.name);
      } finally {
        input.value = null;
        input.disabled = false;
        field.classList.remove("is-loading");
      }
    });

    on("click", "[data-remove-file]", (e) => {
      const button = e.currentTarget;
      const field = button.closest(".field");

      field.classList.add("is-exit");

      field.addEventListener("transitionend", () => {
        field.remove();
      });
    });

    on("click", "[data-clear-file]", async (e) => {
      const button = e.currentTarget;
      const form = button.closest("form");
      const endpoint = form.dataset.uploadEndpoint;
      const field = button.closest(".field");
      const input = field.querySelector('input[type="file"]');

      const data = new FormData();

      data.append("FieldName", input.name);
      data.append("FieldTitle", input.dataset.title);
      data.append("Required", field.dataset.required);
      data.append("Clear", true);
      appendFormSecurity(form, data);

      input.disabled = true;
      field.classList.add("is-loading");

      try {
        const res = await ajax.post(endpoint, { body: data }).text();
        const fieldHtml = document.createRange().createContextualFragment(res);

        field.replaceWith(fieldHtml);
      } catch (error) {
        console.error(error);
      } finally {
        input.disabled = false;
        field.classList.remove("is-loading");
      }
    });
  },
};
